import Link from "next/link"

type Props = {}

let id = 0

function Logo({}: Props) {
  const innerId = id++
  return (
    <Link href="/">
      {/* <img alt="Vixiees logo" src="/main-logo.svg" /> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="209"
        height="42"
        fill="none">
        <path
          fill="#fff"
          d="M58.457 11.137h6.54l6.231 18.873 6.186-18.87h6.54l-8.891 24.142h-7.715l-8.891-24.145zm35.866-6.135a3.726 3.726 0 11-6.377-2.668 3.731 3.731 0 016.377 2.668zM87.53 35.279V11.137h6.144V35.28H87.53zm31.895-24.142l-7.845 11.808 7.799 12.333h-6.886l-4.618-7.277-4.443 7.277h-6.19l7.795-11.766-7.795-12.375h6.886l4.618 7.319 4.447-7.32h6.232zm10.322-6.136a3.722 3.722 0 01-5.179 3.555 3.72 3.72 0 01-2.022-2.09A3.715 3.715 0 01122.299 5a3.715 3.715 0 011.046-2.715 3.72 3.72 0 014.133-.84 3.734 3.734 0 012.022 2.091c.18.467.264.965.247 1.464zm-6.789 30.277V11.137h6.147v24.141h-6.147zm22.871.351c-3.512 0-6.374-1.14-8.586-3.422-2.212-2.281-3.315-5.295-3.309-9.04 0-3.752 1.111-6.752 3.334-9s5.095-3.374 8.616-3.38c3.531 0 6.43 1.098 8.694 3.293 2.265 2.195 3.396 5.121 3.393 8.778.004.788-.054 1.576-.175 2.355h-17.589a5.725 5.725 0 001.746 3.789 5.418 5.418 0 003.876 1.442c2.121 0 3.689-.873 4.706-2.618h6.623a10.581 10.581 0 01-4.051 5.623c-2.004 1.453-4.429 2.18-7.278 2.18zm4.031-18.215a5.765 5.765 0 00-3.943-1.438 5.42 5.42 0 00-3.856 1.438 6.078 6.078 0 00-1.854 3.835h11.416a5.249 5.249 0 00-1.763-3.835zm23.161 18.215c-3.513 0-6.375-1.14-8.587-3.422-2.211-2.281-3.315-5.295-3.309-9.04 0-3.752 1.112-6.752 3.334-9 2.223-2.248 5.099-3.374 8.628-3.38 3.532 0 6.43 1.098 8.695 3.293 2.265 2.195 3.397 5.121 3.397 8.778.004.788-.054 1.576-.175 2.355h-17.606a5.73 5.73 0 001.746 3.789 5.42 5.42 0 003.877 1.442c2.12 0 3.689-.873 4.706-2.618h6.623a10.578 10.578 0 01-4.052 5.623c-2.003 1.453-4.429 2.18-7.277 2.18zm4.03-18.215a5.763 5.763 0 00-3.943-1.438 5.417 5.417 0 00-3.855 1.438 6.074 6.074 0 00-1.855 3.835h11.412a5.245 5.245 0 00-1.759-3.835zm11.612.784c0-2.092.886-3.85 2.659-5.273 1.773-1.422 4.132-2.135 7.077-2.138 2.932 0 5.284.706 7.057 2.117a7.42 7.42 0 012.834 5.727h-6.289c-.175-2.034-1.426-3.05-3.752-3.05a4.512 4.512 0 00-2.701.7 2.247 2.247 0 00-.958 1.917c0 .814.479 1.453 1.438 1.917 1.11.51 2.281.876 3.484 1.088 1.367.261 2.726.588 4.077.98a7.71 7.71 0 013.463 2.084 5.543 5.543 0 011.438 3.989 6.313 6.313 0 01-2.767 5.314c-1.843 1.367-4.195 2.05-7.057 2.05s-5.209-.675-7.04-2.025c-1.828-1.353-2.83-3.298-3.005-5.835h6.252c.248 2.056 1.548 3.084 3.902 3.084a4.538 4.538 0 002.742-.763 2.356 2.356 0 001.051-2.013c0-.834-.48-1.488-1.438-1.963a13.403 13.403 0 00-3.489-1.096 49.884 49.884 0 01-4.077-.959 7.704 7.704 0 01-3.463-2.026 5.195 5.195 0 01-1.438-3.826z"></path>
        <path
          fill={`url(#logo-${innerId})`}
          d="M41.81 0a6.298 6.298 0 014.431 10.779l-8.036 7.952a3.162 3.162 0 000 4.498l8.037 7.953a6.298 6.298 0 11-8.862 8.953l-14.834-14.68a6.303 6.303 0 010-8.953L37.38 1.822A6.298 6.298 0 0141.81 0z"></path>
        <path
          fill="#fff"
          d="M15.949 0a6.302 6.302 0 00-4.431 10.779l7.961 7.877a3.273 3.273 0 010 4.648l-7.961 7.878c-4.001 3.955-1.196 10.774 4.43 10.774a6.31 6.31 0 004.436-1.821l14.83-14.68a6.295 6.295 0 000-8.953l-14.83-14.68A6.302 6.302 0 0015.949 0z"></path>
        <path
          fill="#fff"
          d="M5.702 26.68a5.702 5.702 0 100-11.404 5.702 5.702 0 000 11.404z"></path>
        <defs>
          <linearGradient
            id={`logo-${innerId}`}
            x1="20.679"
            x2="48.126"
            y1="20.978"
            y2="20.978"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#9FAFFF"></stop>
            <stop offset="0.05" stopColor="#9EAAFF"></stop>
            <stop offset="0.47" stopColor="#9482FC"></stop>
            <stop offset="0.8" stopColor="#8E69FB"></stop>
            <stop offset="1" stopColor="#8C60FA"></stop>
          </linearGradient>
        </defs>
      </svg>
    </Link>
  )
}

export default Logo
export type { Props as LogoProps }
